import React from 'react'
import { Link } from 'react-router-dom'
import { recentNews } from '../../utils/contants'
import { styled } from 'styled-components'


const RecentNews = () => {

  return (
    <Container>
        <div className='recent-news-wrapper'>
        <h4>Recent news</h4>
        {
            recentNews.map((news) =>{
                return (
                    <div className="recent-news-box" key={news.newsId}>
                        <Link to={`/news/${news.newsId}`}><p>{news.title}</p></Link>
                        <p className='recent-news-date'>{news.date}</p>
                    </div>
                )
            })
        }  
        </div>
    </Container>
  )
}

const Container = styled.div`
width: 100%;
    .recent-news-wrapper{
        padding: 0 2em;
    }
    h4{
        font-weight: 300;
        font-size: 1.5rem;
        margin-bottom: 0.5em;
    }
    .recent-news-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5em 0em;
        border-bottom: 2px solid var(--color-white-light);
        a{
            width: 80%;
            p{
            font-size: 1.1rem;
            font-weight: 300;
            color: var(--color-muted-black);
                &:hover{
                    color: var(--primary-color);
                }
            }
        }
        .recent-news-date{
            font-size: 0.8rem;
            font-weight: 500;
        }
    }
`;


export default RecentNews